import React, { useEffect, useState } from "react";
import { Download, Receipt } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { modalBody, modalPrimaryBtn, modalSubtitle, modalTitle } from "../ui/modalDesign";

function ReceiptList({ programs, childData }: any) {
  const [childPrograms, setChildPrograms] = useState<any>({});
  const navigate = useNavigate();

  useEffect(() => {
    if (Array.isArray(programs)) {
      setChildPrograms({ programs });
    } else {
      setChildPrograms(programs || {});
    }
  }, [programs]);

  const handleDownloadReceipt = (programId: number) => {
    navigate(`/parent/receipt/${programId}`);
  };

  const programsList = childPrograms.programs || [];
  const learnerName =
    childData?.firstName && childData?.lastName
      ? `${childData.firstName} ${childData.lastName}`
      : childPrograms.firstName && childPrograms.lastName
        ? `${childPrograms.firstName} ${childPrograms.lastName}`
        : "Receipts";

  return (
    <div className={`${modalBody} max-h-[85vh] overflow-y-auto`}>
      {programsList.length > 0 ? (
        <>
          <div className="mb-5 flex items-center gap-3 rounded-[14px] border border-[#efe6f1] bg-[#FBF8FC] px-4 py-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-ryd-primaryLess1 text-ryd-primary">
              <Receipt size={18} />
            </div>
            <div>
              <p className="text-[12px] font-medium uppercase tracking-wide text-[#94a3b8]">Learner</p>
              <h2 className="font-[AvertaStd-Semibold] text-[16px] text-ryd-headerTextPrimary">{learnerName}</h2>
            </div>
          </div>

          <h1 className={modalTitle}>Payment Receipts</h1>
          <p className={`${modalSubtitle} mb-5`}>Download receipts for paid programs.</p>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {programsList.map((program: any, i: number) => (
              <div key={i} className="rounded-[16px] border border-[#efe6f1] bg-white p-4 shadow-sm">
                <div className="mb-3 flex items-start justify-between gap-2">
                  <h3 className="font-[AvertaStd-Semibold] text-[15px] text-ryd-headerTextPrimary">
                    {program.package?.title || "Program Receipt"}
                  </h3>
                  <Receipt className="h-5 w-5 shrink-0 text-ryd-primary/50" />
                </div>

                <div className="mb-4 space-y-2 text-[13px]">
                  <div className="flex justify-between text-[#8b9aab]">
                    <span>Level</span>
                    <span className="font-semibold text-[#334155]">{program.package?.level || "N/A"}</span>
                  </div>
                  <div className="flex justify-between text-[#8b9aab]">
                    <span>Duration</span>
                    <span className="font-semibold text-[#334155]">
                      {program.package?.weekDuration || "N/A"} Weeks
                    </span>
                  </div>
                </div>

                {program.isPaid && (
                  <button
                    type="button"
                    onClick={() => handleDownloadReceipt(program.id)}
                    className={modalPrimaryBtn}
                  >
                    <Download size={15} /> Download Receipt
                  </button>
                )}
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="rounded-[16px] border border-dashed border-[#e8dce8] bg-[#FBF8FC] px-6 py-12 text-center">
          <Receipt className="mx-auto mb-3 h-12 w-12 text-[#d4c4de]" />
          <p className="text-[14px] text-[#8b9aab]">No receipts found</p>
        </div>
      )}
    </div>
  );
}

export default ReceiptList;
